export const languages = [
  { value: 'en', label: 'English' },
  { value: 'cs', label: 'Čeština' },
  { value: 'kk', label: 'Қазақша' },
  { value: 'sk', label: 'Slovenčina' },
  { value: 'ru', label: 'Русский' },
  { value: 'de', label: 'Deutsch' },
  { value: 'sr', label: 'Srpski' },
  { value: 'pl', label: 'Polskie' }
];

export const sizes = [
  { value: '1 - 49', label: '1 - 49 zaměstnanců' },
  { value: '50 - 199', label: '50 - 199 zaměstnanců' },
  { value: '200 - 499', label: '200 - 499 zaměstnanců' },
  { value: '500', label: '500 a více zaměstnanců' }
];

export const urls = {
  howTo: { cs: 'https://www.mluvii.com/jak-na-to/', en: 'https://www.mluvii.com/how-it-works/?lang=en' },
  functions: { cs: 'https://www.mluvii.com/', en: 'https://www.mluvii.com/?lang=en' },
  gdpr: { cs: 'https://www.mluvii.com/gdpr/', en: 'https://www.mluvii.com/gdpr/?lang=en' },
  logIn: 'https://app.mluvii.com/login/',
  sendAgain: 'https://app.mluvii.com/login/Account/PasswordRecovery'
};

export enum LinkType {
  howTo = 'howTo',
  functions = 'functions',
  logIn = 'logIn',
  sendAgain = 'sendAgain',
  gdpr = 'gdpr'
}
